import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CalendarBuilder } from '@root/component/multi-calendar/multi-calendar.service';
import { MultiHouseCalendarService } from '@root/router/component/calendar/multi-house-calendar/multi-house-calendar.service';
import moment from 'moment';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'host-single-rt-status-calendar-v2',
  templateUrl: './single-rt-status-calendar-v2.component.html',
  styleUrls: ['./single-rt-status-calendar-v2.component.scss'],
})
export class SingleRtStatusCalendarV2Component implements OnInit, OnDestroy {
  @Input() id;
  listOfMonthOption = [];
  month;

  private destroy$ = new Subject<void>();
  constructor(private cb: CalendarBuilder, private calendarSrv: MultiHouseCalendarService) {}

  ngOnInit() {
    this.initMonthOptions();

    this.calendarSrv.dateChangeRaw$.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.month = moment(value[0]).format('YYYY-MM');
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onMonthChange(month) {
    this.calendarSrv.scrollRaw$.next(month);
  }

  private initMonthOptions() {
    const list = this.cb.getAllMonth();
    this.listOfMonthOption = list.map((item) => ({
      label: item.i18nTitle,
      value: item.date,
    }));
  }
}
